import { render, staticRenderFns } from "./index_Hot.vue?vue&type=template&id=55091194&scoped=true"
import script from "./index_Hot.vue?vue&type=script&lang=js"
export * from "./index_Hot.vue?vue&type=script&lang=js"
import style0 from "./index_Hot.vue?vue&type=style&index=0&id=55091194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55091194",
  null
  
)

export default component.exports